import React, {useState} from "react"
import HeadingSkeleton from "../../../components/skeletons/HeadingSkeleton";
import {Skeleton} from 'antd';

export default function PrivacyPolicySkeleton() {
    const [pagesData,setPagesData] = useState()

    return(
        <div className={'policy'}>
            <h6 className={'setting-heading mb-3'}><HeadingSkeleton height={20} maxWidth={200}/></h6>
            <Skeleton active />
            <br/>
            <Skeleton active />
            <br/>
            <Skeleton active />
            <br/>
            <Skeleton active />
            <br/>
            <Skeleton active />
            <br/>
            <Skeleton active />
        </div>
    )
}